import { Component, Inject, OnInit } from "@angular/core";
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from "@angular/material/bottom-sheet";
import { ESortDirection } from "src/app/Models/Enum/sort-direction";

@Component({
  selector: "app-sort",
  templateUrl: "./sort.component.html",
  styleUrls: ["./sort.component.scss"],
})
export class SortComponent implements OnInit {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private _bottomSheetRef: MatBottomSheetRef<SortComponent>
  ) {}

  ngOnInit(): void {}

  onNoClick(): void {
    this._bottomSheetRef.dismiss();
  }

  sortOrders(sort: ESortDirection): void {
    this.data.sortType = sort;
    this.closeMenu();
  }


  closeMenu(): void {
    this._bottomSheetRef.dismiss({
      sortType: this.data.sortType,
    });
  }
}
